
<template>
  <v-container fluid>
    <company-info></company-info>
  </v-container>
</template>

<script>

export default {
  name: 'CompanySettings',
  components: {
    CompanyInfo: ()=>import('../../components/company/CompanyInfo.vue'),
  },
}
</script>

<style scoped>

</style>